<template>
    <div class="cert-area--wrap scroll-primary">
        <v-sheet color="border" class="cert-area">
            <v-img src="/images/ci.svg" max-width="700" class="cert-area__bg cert-area__bg--ci w-100" />
            <v-img src="/images/sub/cert/bg.png" class="cert-area__bg cert-area__bg--bottom w-100" />
            <div class="cert-area__inner">
                <div class="mb-64">
                    <v-img src="/images/sub/cert/award.svg" max-width="164" class="cert-award mx-auto mb-38" />
                    <h3 class="font-size-48 text-center">근무 확인서</h3>
                </div>
                <div class="mb-64">
                    <h4 class="font-size-24 mb-4">근무 확인 신청자</h4>
                    <v-divider class="primary border-2" />
                    <div class="text-center">
                        <vertical-table-row term="성명"> {{ value.resume.personalInformation.name }} </vertical-table-row>
                        <vertical-table-row term="생년월일"> {{ value.resume.personalInformation.bornAt?.toDate?.() }} </vertical-table-row>
                    </div>
                </div>
                <div class="mb-64">
                    <h4 class="font-size-24 mb-4">근무 이력</h4>
                    <vertical-form-table v-model="form" v-bind="{ items, mode }" @input="emit">
                        <template #기업명> {{ form?.company?.name || "-" }} </template>
                    </vertical-form-table>
                </div>
                <v-card elevation="0" color="grey-f7" class="mb-110">
                    <div class="pa-40 text-center">
                        <h4 class="font-size-24 font-weight-medium mb-20">위 사람은 마이스펙을 통해 ({{ form?.company?.name || "-" }})에서 근무한 사실을 증명합니다.</h4>
                        <p class="font-size-18 grey-6--text">
                            {{ certifiedAt }}
                        </p>
                    </div>
                </v-card>
                <div class="bottom-logo">
                    <v-img src="/images/sub/cert/sign.png" max-width="98" class="bottom-logo__sign" />
                    <v-layout justify-center align-center class="bottom-logo__inner">
                        <p class="font-size-18 mr-48">마이스펙 운영사</p>
                        <v-img src="/images/sub/cert/logo.jpg" max-width="276" class="bottom-logo__logo" />
                    </v-layout>
                </div>
            </div>
        </v-sheet>
    </div>
    <!-- <v-responsive :aspect-ratio="2 / 3">
        <v-sheet class="fill-height" v-bind="{ outlined }">
            <v-layout fill-height column justify-center align-center>
                <v-card-title> 근무확인서</v-card-title>
                <v-card-text>
                    <v-card-subtitle>근무 확인 신청자</v-card-subtitle>
                    <v-divider class="primary pt-1" />
                    <vertical-table-row term="인적사항">
                        <vertical-table-row term="성명"> {{ value.resume.personalInformation.name }} </vertical-table-row>
                        <vertical-table-row term="생년월일"> {{ value.resume.personalInformation.bornAt?.toDate?.() }} </vertical-table-row>
                    </vertical-table-row>

                    <v-card-subtitle class="mt-30">근무 이력</v-card-subtitle>
                    <vertical-form-table v-model="form" v-bind="{ items, mode }" @input="emit">
                        <template #기업명> {{ form?.company?.name || "-" }} </template>
                    </vertical-form-table>

                    <v-sheet rounded color="grey lighten-4" class="mt-30">
                        <v-card-text>
                            <v-layout column justify-center align-center>
                                <span> 위 사람은 마이스펙을 통해 {{ form?.company?.name || "-" }} 에서 근무한 사실을 증명합니다. </span>
                                <span>{{ certifiedAt }}</span>
                            </v-layout>
                        </v-card-text>
                    </v-sheet>
                </v-card-text>
            </v-layout>
        </v-sheet>
    </v-responsive> -->
</template>

<script>
import { attrs_input, EMPLOYMENT_TYPES, initApplication } from "@/assets/variables";

import VerticalTableRow from "@/components/dumb/vertical-table-row.vue";
import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";

export default {
    props: {
        value: { type: Object, defatul: initApplication },

        mode: { type: String, default: "view" },
        outlined: { type: Boolean, default: false },
    },
    components: {
        VerticalTableRow,
        VerticalFormTable,
    },
    data: () => ({
        form: initApplication(),

        className: Math.random().toString().slice(2),
    }),
    computed: {
        items() {
            return [
                {
                    term: "기업명",
                },
                {
                    type: "select",
                    term: "고용형태",
                    key: "certification.employmentType",
                    data: EMPLOYMENT_TYPES[this.form?.certification?.employmentType]?.text || "-",
                    items: (this.value?.recruitment?.employment?.types || Object.keys(EMPLOYMENT_TYPES)).map((key) => EMPLOYMENT_TYPES[key]).filter((item) => item),
                    class: `application-certification-employmentType-${this.className}`,
                    menuProps: { attach: `.application-certification-employmentType-${this.className}`, contentClass: "application-certification-employmentType-content" },
                },
                {
                    type: "text",
                    term: "업무 / 행사명",
                    key: "certification.jobDescription",
                },
                {
                    type: "duration",
                    term: "근무기간",
                    key: "certification.jobDurationAts",
                },
            ].map((item) => ({ ...item, ...attrs_input }));
        },
        certifiedAt() {
            return this.$dayjs(this.form?.certifiedAt || Date.now()).format("YYYY년 MM월 DD일");
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            const form = initApplication(this.value);
            if (form.certification.jobDurationAts[0]) form.certification.jobDurationAts[0] = form.certification.jobDurationAts[0].toDate();
            if (form.certification.jobDurationAts[1]) form.certification.jobDurationAts[1] = form.certification.jobDurationAts[1].toDate();
            this.form = form;
        },
        emit() {
            const { certification } = this.form;
            this.$emit("input", { ...this.value, certification });
        },
    },
};
</script>

<style lang="scss" scoped>
@media print {
    html,
    body,
    .cert-area {
        min-width: 0;
        max-width: 210mm;
        width: 210mm;
        height: 297mm;
        margin: 0;
    }

    @page{
        margin: 0;
    }

    .cert-area {
        padding: 90px;
    }

    * {
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
    }

    .cert-area__bg--ci {
        max-width: 462px !important;
    }
    .cert-award {
        max-width: 130px !important;
    }
    .bottom-logo__sign {
        max-width: 48px !important;
    }
    .bottom-logo__logo {
        max-width: 182px !important;
    }
    .mb-110 {
        margin-bottom: 48px !important;
    }
    .mb-38 {
        margin-bottom: 26px !important;
    }
    .mb-64 {
        margin-bottom: 48px !important;
    }
    .mb-20 {
        margin-bottom: 12px !important;
    }
    .mr-48 {
        margin-right: 32px !important;
    }
    .pa-40 {
        padding: 20px !important;
    }
    .font-size-48 {
        font-size: 30px !important;
    }
    .font-size-24 {
        font-size: 16px !important;
    }
    .font-size-18 {
        font-size: 12px !important;
    }
}

::v-deep .application-certification-employmentType-content > .v-select-list {
    background: white;
}
</style>